import React from "react";
import book1 from './resources/when-breath-becomes-air.jpeg';
import book2 from './resources/and-then-there-were-none.jpeg';
import book3 from './resources/mans-search-for-meaning.jpeg';
import book4 from './resources/the-wife-and-the-widow.jpeg';
import book5 from './resources/readme-txt.jpeg';
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { WHEN_BREATH_BECOMES_AIR } from "./constants";
import ParticlesBackground from "./ParticlesBackground";
import { NavButton } from "./NavigationBar";

const BookReviews = () => {
    return (
        <div className="bg-gradient-to-r from-red-400 to-pink-500 p-5 w-10/12 md:w-6/12 rounded-lg place-self-center md:place-self-start">
        <div className="font-bold text-center mb-3">Book reviews</div>
            <div className="text-left mt-5">
                I've been trying to write reviews for books that I read as a way to maintain a habit of writing regularly.
                <br />I also find writing reviews as a way to solidify and better understand my own tastes.
                <br /><br />These are some of my favourite reads (recency bias has obviously crept in):
                <ol className="pl-5 pt-3">
                    <li className="list-disc">
                        <span className="hover:border-b-4 hover:cursor-pointer">When Breath Becomes Air</span>
                    </li>
                    <li className="list-disc">
                        <span className="hover:border-b-4 hover:cursor-pointer">The Long Call (Two Rivers #1)</span>
                    </li>
                </ol>
            </div>
        </div>
    );
};

const RandomMusings = () => {
    return (
        <div className="bg-gradient-to-r from-red-400 to-pink-500 p-5 drop-shadow-xl rounded-lg w-10/12 md:w-6/12 place-self-center md:place-self-stretch"> 
            <div className="font-bold text-center mb-3">Random musings</div>
            <div>
                I also think that I should start maintaing a separate section where I post ramblings.
                <br /> Here are some good ones
                <ol className="pl-5 pt-3">
                    <li className="list-disc">
                        <span className="hover:border-b-4 hover:cursor-pointer">When Breath Becomes Air</span>
                    </li>
                    <li className="list-disc">
                        <span className="hover:border-b-4 hover:cursor-pointer">The Long Call (Two Rivers #1)</span>
                    </li>
                </ol>
            </div>
        </div>
    );
};

const Book = ({ bookPath, altText, urlPath, bookName }) => {
    const navigate = useNavigate();

    return (
        <div 
            className={`md:w-2/12 md:h-2/12 hover:ease-in-out flex-shrink-0 hover:scale-125 duration-500 hover:cursor-pointer`}
            onClick={() => {
                navigate(`/articles/${urlPath}`, { state: { name: bookName }});
            }}
        >
            <img src={bookPath} alt={altText} className={`h-32 w-auto md:h-64 md:w-auto`} />
        </div>
    );
};

export const Blog = () => {
    return (
        <div className={`flex flex-col h-full w-full`}>
        <div className="z-10 flex flex-row justify-between place-self-center w-10/12 p-2">
            <div className="font-mono text-lg md:text-2xl p-2 font-bold">Blog</div>
            {/* <div className="text-lg bg-gradient-to-r from-red-400 to-pink-500 rounded-lg p-2">Home</div> */}
            <div className="flex flex-row gap-4">
                <NavButton buttonName={'Home'} redirectPath={'/personal-site/#'} />
                <NavButton buttonName={"Travel"} redirectPath={`/personal-site/#/travel`} />
                <NavButton buttonName={"Projects"} redirectPath={`/personal-site/#/projects`} />
            </div>
        </div>
            <div className={`flex flex-col md:flex-row md:justify-between md:w-10/12 mt-10 md:mt-10 place-self-center gap-5 z-10`}>
                <BookReviews />
                <RandomMusings />
            </div>
            <div className="bg-gradient-to-r from-yellow-600 to-red-500 w-10/12 bg-blue-500 place-self-center text-center mt-5 h-10 rounded-lg pt-2 font-bold z-10">Featured</div>
            <div className="z-10 pl-52 md:p-12 md:pl-10 h-1/2 p-5 flex overflow-y-visible overflow-x-auto gap-4 rounded-lg mt-5 md:mb-10 md:mt-5 bg-gradient-to-b from-yellow-600 to-orange-700 w-10/12 place-self-center place-items-center justify-around md:flex md:flex-row">
                <Book bookPath={book1} alt={"When breath becomes air paperback cover"} urlPath={'when-breath-becomes-air'} bookName={WHEN_BREATH_BECOMES_AIR} />
                <Book bookPath={book2} alt={"And then there were none paperback cover"} urlPath={'and-then-there-were-none'} />
                <Book bookPath={book3} alt={"Man's search for meaning paperback cover"} urlPath={'mans-search-for-meaning'} />
                <Book bookPath={book4} alt={"The Wife and the Widow paperback cover"} urlPath={'the-wife-and-the-widow'} />
                <Book bookPath={book5} alt={"Readme.txt paperback cover"} urlPath={'readme-txt'} />
            </div>
            <ParticlesBackground />
            {/* { triggerBookAnimation && <div className={`h-screen w-full absolute ${triggerBookAnimation ? 'blur-md' : ''}`}></div>} */}
        </div>
    );
};

export default Blog;